
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class AppSelectInput extends Vue {
    @Prop() value!: object;
    @Prop() label!: string;
    @Prop() name!: string;
    @Prop() disabled!: boolean;
    @Prop({default: false}) error!: string | boolean;
    @Prop() showError!: boolean;
    @Prop() helpText!: null | string;
    @Prop() options!: object;

    active: boolean = false;

}
